import { defineService } from '@wix/services-definitions';
export const MembersServiceDefinition = defineService('members-area/members-service');
//# sourceMappingURL=index.js.map